import { Table } from '@boozallen-uip/uswds-react-core';
import { IndeterminateSpinner } from '@boozallen-uip/uswds-react-loading';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { VendorContext }  from '../../Vendor/VendorContext';

export default function ProductUnauthListTable({ products, isLoading, emptyMessage }) {
  const { vendors } = useContext(VendorContext);

  const getVendorNameByProduct = (product) => {
    const directVendorName = product?.vendor?.name;
    if (directVendorName) {
      return directVendorName;
    }

    const vendorId = product?.vendor?.id || product?.vendorId;
    if (!vendorId) {
      // Agency-owned (Buyer) products have no vendor; show the owning agency name instead of blank.
      return product?.agencyName || "";
    }

    const vendorRecord = vendors.find((vendor) => String(vendor?.id) === String(vendorId));
    return vendorRecord?.name || "";
  };

  return isLoading ?
    <IndeterminateSpinner type="circle" color="blue" /> :
    <Table border={false} style={{ width: "100%" }} className='text-primary-darker'>
      <thead>
        <tr className='[&>th]:text-primary-darker'>
          <th scope="col">
            <div>
              <b className="text-primary-darker font-bold">Product</b>
            </div>
          </th>
          <th scope="col">
            <div>
              <b className="text-primary-darker font-bold">Product Category</b>
            </div>
          </th>
          <th scope="col">
            <div>
              <b className="text-primary-darker font-bold">PSC</b>
            </div>
          </th>
          <th scope="col">
            <div>
              <b className="text-primary-darker font-bold">Vendor</b>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {products.length === 0 ? (
          <tr>
            <td colSpan={4} className="py-4 italic text-base-dark" role="status" aria-live="polite">
              {emptyMessage}
            </td>
          </tr>
        ) : products.map((product) => (
          <tr key={product.id} style={{ justifyContent: 'space-between' }}>
            <td className="text-primary-darker">{product.name}</td>
            <td className="text-primary-darker">{product.category}</td>
            <td className="text-primary-darker">{product.pscCode}</td>
            <td className="text-primary-darker">{getVendorNameByProduct(product)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
}

ProductUnauthListTable.propTypes = {
  products: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  emptyMessage: PropTypes.string
}

ProductUnauthListTable.defaultProps = {
  isLoading: false,
  emptyMessage: "No products found."
}
